import { Edit } from 'react-admin'

// Use it instead of native Edit. We want pessimistic to be our default option
export const PessimisticEdit: typeof Edit = (props) => (
    <Edit mutationMode="pessimistic" {...props} />
)

PessimisticEdit.propTypes = Edit.propTypes
